// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"74476f84","238":"249b51da","239":"22e73381","453":"a367568f","455":"ec84b109","762":"9d5a436a"}[chunkId] + ".chunk.js";
};